/** Shown instead of the dashboard when the build has no valid API address (see lib/env.ts). */
export function ApiNotConfigured({ problem }: { problem: string }) {
  return (
    <main className="bg-background text-foreground flex min-h-svh items-center justify-center p-6">
      <section
        role="alert"
        aria-labelledby="api-not-configured-title"
        className="bg-card w-full max-w-lg space-y-4 rounded-xl border p-6 shadow-sm"
      >
        <h1 id="api-not-configured-title" className="text-xl font-semibold">
          API address not configured
        </h1>
        <p className="text-muted-foreground text-sm">
          The dashboard reads and saves everything through the Milqit API, so it can&apos;t start
          without knowing where that is.
        </p>
        <p className="text-sm">{problem}.</p>
        <p className="text-muted-foreground text-sm">
          Set <code className="font-mono">VITE_API_URL</code> in the root <code>.env</code> (for
          example <code className="font-mono">http://localhost:4000</code>), make sure the API is
          running, then restart the dashboard.
        </p>
      </section>
    </main>
  );
}
